var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpaces = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1763 68C23.9366 68 23.701 67.9378 23.4925 67.8197L11.7032 61.1414C11.2686 60.8952 11 60.4342 11 59.9347V46.065C11 45.5655 11.2686 45.1046 11.7032 44.8583L23.4925 38.1801C23.9167 37.94 24.4358 37.94 24.86 38.1801L36.6493 44.8583C37.0839 45.1046 37.3525 45.5655 37.3525 46.065V59.9347C37.3525 60.4342 37.0839 60.8952 36.6493 61.1414L24.86 67.8197C24.6515 67.9378 24.4159 68 24.1763 68ZM13.7739 59.1261L24.1763 65.018L34.5786 59.1261V46.8736L24.1763 40.9817L13.7739 46.8722V59.1261Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1763 68C55.9366 68 55.701 67.9378 55.4925 67.8197L43.7032 61.1414C43.2686 60.8952 43 60.4342 43 59.9347V46.065C43 45.5655 43.2686 45.1046 43.7032 44.8583L55.4925 38.1801C55.9167 37.94 56.4358 37.94 56.86 38.1801L68.6493 44.8583C69.0839 45.1046 69.3525 45.5655 69.3525 46.065V59.9347C69.3525 60.4342 69.0839 60.8952 68.6493 61.1414L56.86 67.8197C56.6515 67.9378 56.4159 68 56.1763 68ZM45.7739 59.1261L56.1763 65.018L66.5786 59.1261V46.8736L56.1763 40.9817L45.7739 46.8722V59.1261Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1763 42C39.9366 42 39.701 41.9378 39.4925 41.8197L27.7032 35.1414C27.2686 34.8952 27 34.4342 27 33.9347V20.065C27 19.5655 27.2686 19.1046 27.7032 18.8583L39.4925 12.1801C39.9167 11.94 40.4358 11.94 40.86 12.1801L52.6493 18.8583C53.0839 19.1046 53.3525 19.5655 53.3525 20.065V33.9347C53.3525 34.4342 53.0839 34.8952 52.6493 35.1414L40.86 41.8197C40.6515 41.9378 40.4159 42 40.1763 42ZM29.7739 33.1261L40.1763 39.018L50.5786 33.1261V20.8736L40.1763 14.9817L29.7739 20.8722V33.1261Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaces);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spaces.af30cb628c4ca3a5fdbf5cae9ededee5.svg";